/*
 * Copyright (C) 2015 Spanning Cloud Apps LLC.  All rights reserved.
 */
import './bulkRestoreNavigator.tpl.html';

angular
  .module('batch.bulkrestore.navigator', [])
  /**
   * Controller for the bulkrestore.navigator template.
   */
  .controller(
    'BulkRestoreNavigatorCtrl',
    function (
      $scope,
      $filter,
      $rootScope,
      batchUtils,
      pagingUtils,
      batchErrors,
      BATCH_RESULTS,
      BULK_RESTORE_BATCH_RESULT_TABS,
      BULK_RESTORE_EVENTS,
      NON_RESTORABLE_EVENT_CODE
    ) {
      $scope.resultTabs = BULK_RESTORE_BATCH_RESULT_TABS;

      $scope.batchHasErrors = false;
      if (batchErrors) {
        if (batchErrors[NON_RESTORABLE_EVENT_CODE]) {
          if (Object.keys(batchErrors).length > 1) {
            $scope.batchHasErrors = true;
          }
        } else if (Object.keys(batchErrors).length > 0) {
          $scope.batchHasErrors = true;
        }
      }

      $scope.batchHasNonrestorable = !!batchErrors[NON_RESTORABLE_EVENT_CODE];

      $scope.showSuccess =
        batchUtils.currentBatch &&
        batchUtils.currentBatch.bulkRestoreData &&
        batchUtils.currentBatch.bulkRestoreData.objectsComplete > 0;

      $scope.showOverwrites =
        batchUtils.currentBatch &&
        batchUtils.currentBatch.bulkRestoreData &&
        batchUtils.currentBatch.bulkRestoreData.overwriteMap &&
        !_.isEmpty(batchUtils.currentBatch.bulkRestoreData.overwriteMap);

      $scope.showSpecificFields =
        batchUtils.currentBatch &&
        batchUtils.currentBatch.bulkRestoreData &&
        batchUtils.currentBatch.bulkRestoreData.specificFields &&
        !_.isEmpty(batchUtils.currentBatch.bulkRestoreData.specificFields);

      $scope.$parent.currentTab = $scope.batchHasErrors ? $scope.resultTabs.ERRORS : $scope.resultTabs.SUCCESS;

      $scope.pagingParam = pagingUtils.pagingInfo.bulkRestoreDetails;

      /**
       * Function to determine if item is selected.
       * @returns {Boolean} - Flag if the item is selected or not.
       */
      $scope.isSelected = function (tab) {
        return $scope.$parent.currentTab === tab;
      };

      /**
       * Function to show the correct content for the selected tab.
       */
      $scope.showTab = function (tab) {
        $scope.$parent.currentTab = tab;
      };

      /**
       * Function to collapse all open collapsible containers.
       */
      $scope.collapseAll = function () {
        $rootScope.$emit(BULK_RESTORE_EVENTS.COLLAPSE_ALL);
      };

      $scope.setPage = function (page) {
        $scope.pagingParam.currentPage = page;
      };
    }
  );
